var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-box',{attrs:{"app-list":[{code: 1, name: 'Suraj'}, {code: 2, name: 'jyostna'}]}})}
var staticRenderFns = []

export { render, staticRenderFns }